module.exports = __webpack_public_path__ + "img/logoUL_250x104.cf7766ea.png";